import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  inject,
  Input,
  OnChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { RbacService } from '@core/services/rbac/rbac.service';
import { ActionsFlags } from '@api/model/my-api';

const TEST_MODE = false;

@Directive({
  selector: '[hdHasAccess]',
  standalone: true,
})
export class HasAccessDirective implements OnChanges {
  private rbacService = inject(RbacService);
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);

  @Input({ required: true }) hdHasAccess!: string | undefined;
  @Input() hdHasAccessAllowedActions?: Record<string, ActionsFlags>;
  @Input() hdHasAccessCheckPossibility?: boolean;

  ngOnChanges() {
    this.viewContainer.clear();

    if (this.hasAccess()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (TEST_MODE) {
      const compRef = this.viewContainer.createComponent(AccessDeniedComponent);
      compRef.instance.action = this.hdHasAccess!;
    }
  }

  private hasAccess() {
    if (this.hdHasAccess) {
      if (this.hdHasAccessAllowedActions) {
        // Check against specific set of actions
        return this.hdHasAccessCheckPossibility
          ? this.hdHasAccessAllowedActions[this.hdHasAccess]?.access &&
              this.hdHasAccessAllowedActions[this.hdHasAccess]?.possible
          : this.hdHasAccessAllowedActions[this.hdHasAccess]?.access;
      }
      // Check against global actions
      return this.hdHasAccessCheckPossibility
        ? this.rbacService.hasAccessAndPossibilityForGlobalAction(
            this.hdHasAccess,
          )
        : this.rbacService.hasAccessForGlobalAction(this.hdHasAccess);
    }

    return true;
  }
}

/**
 * Dummy component just for testing
 */
@Component({
  selector: 'hd-access-denied',
  standalone: true,
  template: `
    <div style="color:red;border: 1px solid red; padding: 2px;">
      {{ action }}
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
class AccessDeniedComponent {
  @Input({ required: true }) action!: string;
}
